module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAABbUlEQVR4Xu3aUU7DMBRFwWb/iw4C8UNFkMNpUqcdvnOFO1z7WaHLzU8SWFJa+AYwlgAgwCgQ4xoIMArEuAYCjAIxroFnAa7ruv71u5Zlecs/xvCHBvh7fQDawlEgxjUQYBSIcQ0EGAVi/LAGvsu1B6AGRoEY10CAUSDGNRBgFIhxDXwVwKveG6dpIMC7N9J7QfY+H3few+IaGCkBAowCMa6BAKNAjF+2gbNMbYAauPEP75O+KaGBGqiBXwJ7h8Le52PRNuO2cJQFCHDsDDxqy79NAwFO+r5RA79PgP9+RRkgQEPklIu0IWKI/Nxq94f23oYc/fzo/doQMUQMEUPkU2D2M23vmekMjFMbIMDnXnue3sDRBVz9ucPugVeHGV0/wFGpjecAzgIY1zFdfPQF68MaOJ1AXBBAgFEgxjUQYBSIcQ0EGAVi/OENjOt52fjwPfBlBeIHAwgwCsS4BgKMAjGugQCjQIxrIMAoEOMfjaGwbwyYle8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kshtb-icon.png
// module id = R7fe
// module chunks = 1